import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-gray-900 to-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl sm:text-6xl font-extrabold text-white mb-6">About InfoDrop.in</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Your trusted source for gaming giveaways, tech guides, and helpful information
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            {/* Our Mission */}
            <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-3xl p-8 md:p-12">
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-xl">
                  <i className="ri-target-line text-white text-2xl"></i>
                </div>
                <h2 className="text-3xl font-bold text-gray-900">Our Mission</h2>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed">
                InfoDrop.in was created to provide safe, reliable, and educational information about gaming giveaways and technology. We believe in empowering our community with knowledge while maintaining the highest standards of safety and transparency.
              </p>
            </div>

            {/* What We Do */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">What We Do</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-purple-50 rounded-2xl p-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-purple-500 rounded-xl mb-4">
                    <i className="ri-gift-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Giveaway Information</h3>
                  <p className="text-gray-700 leading-relaxed">
                    We provide comprehensive guides about Free Fire and BGMI giveaways, helping you participate safely and understand how they work.
                  </p>
                </div>
                <div className="bg-blue-50 rounded-2xl p-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-500 rounded-xl mb-4">
                    <i className="ri-shield-check-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Safety Education</h3>
                  <p className="text-gray-700 leading-relaxed">
                    We educate our community about online safety, scam prevention, and best practices for protecting personal information.
                  </p>
                </div>
                <div className="bg-green-50 rounded-2xl p-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-green-500 rounded-xl mb-4">
                    <i className="ri-lightbulb-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Tech Guides</h3>
                  <p className="text-gray-700 leading-relaxed">
                    From gaming tips to app tutorials, we share helpful technology guides that make your digital life easier.
                  </p>
                </div>
                <div className="bg-yellow-50 rounded-2xl p-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-yellow-500 rounded-xl mb-4">
                    <i className="ri-community-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Community Support</h3>
                  <p className="text-gray-700 leading-relaxed">
                    We build a trusted community where gamers and tech enthusiasts can learn and grow together safely.
                  </p>
                </div>
              </div>
            </div>

            {/* Our Values */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Our Values</h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-500 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Transparency</h3>
                    <p className="text-gray-700 leading-relaxed">
                      We are upfront about what we do and don't do. We clearly state that we are not affiliated with any game companies and provide information for educational purposes only.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-500 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Safety First</h3>
                    <p className="text-gray-700 leading-relaxed">
                      Your security is our priority. We never ask for passwords, and we educate our community about online safety practices.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-500 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Quality Content</h3>
                    <p className="text-gray-700 leading-relaxed">
                      We provide well-researched, accurate, and helpful information that genuinely benefits our community.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-500 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">AdSense Compliance</h3>
                    <p className="text-gray-700 leading-relaxed">
                      We follow all Google AdSense policies and maintain ethical content standards. No fake promises or misleading information.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Important Notice */}
            <div className="bg-yellow-50 border-2 border-yellow-300 rounded-2xl p-8">
              <div className="flex items-start space-x-4">
                <i className="ri-alert-line text-yellow-600 text-3xl flex-shrink-0"></i>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Important Notice</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <strong>InfoDrop.in is a fan-made information platform.</strong> We are not affiliated with, endorsed by, or connected to Garena, Free Fire, Krafton, BGMI, or any official game developers.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    We do not organize or conduct giveaways ourselves. We provide educational information about how giveaways work and safety guidelines to help you participate safely in community-organized events.
                  </p>
                </div>
              </div>
            </div>

            {/* Contact CTA */}
            <div className="bg-gradient-to-br from-blue-600 to-cyan-500 rounded-3xl p-12 text-center">
              <h2 className="text-3xl font-bold text-white mb-4">Have Questions?</h2>
              <p className="text-xl text-blue-100 mb-4">
                We're here to help! Reach out to us anytime.
              </p>
              <p className="text-lg text-white mb-8">
                Email: <a href="mailto:contact.infodrop.in@gmail.com" className="font-semibold underline hover:text-blue-100 cursor-pointer">contact.infodrop.in@gmail.com</a>
              </p>
              <a
                href="/contact"
                className="inline-block bg-white text-blue-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-blue-50 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
